// RecBarbershop.jsx - Professional Men's Grooming Guide
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18n";
import "./recommended.css";

const recommendedItems = [
  { title: "hairTrendsStylingGuide", image: "images/hair.jpg", slug: "hair-&-nail-salon" },
  { title: "mensGroomingMustacheStyles", image: "images/barbershop.jpg", slug: "barbershop" },
  { title: "tattooIdeasArtistGuide", image: "images/tattoo.jpg", slug: "tattoo-&-piercing-shops" },
  { title: "hairRemovalSkincare", image: "images/hair1.jpg", slug: "hair-removal" },
  { title: "browLashEnhancement", image: "images/brows.jpg", slug: "makeup-&-brows-&-lashes" },
  { title: "spaWellnessTreatments", image: "images/massage.jpg", slug: "massage-&-aesthetic-medicine" },
];

export default function RecBarbershop() {
  const { t, lang } = useI18n();
  
  const handleTocClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <div className="rec-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <details className="rec-mobile-panel" role="navigation" aria-label="Recommended quick links">
        <summary>
          {t('recommendedServices')}
                    <span className="rec-plus" aria-hidden="true">+</span>

          <span className="rec-plus" aria-hidden="true"></span>
        </summary>
        <ul className="rec-quick-list">
          {recommendedItems.map((it) => (
            <li key={it.slug}>
              <Link to={`/rec/${it.slug}`}>{t(it.title)}</Link>
            </li>
          ))}
        </ul>
      </details>

      <aside className="rec-left" aria-label="Recommended Services">
        <h2 className="rec-left__title">{t('recommendedServices')}</h2>
        <ul className="rec-left__list">
          {recommendedItems.map((it) => (
            <li key={it.slug} className="rec-left__item">
              <Link to={`/rec/${it.slug}`} className="rec-left__link">
                <img className="rec-left__thumb" src={`/${it.image}`} alt="" />
                <span className="rec-left__label">{t(it.title)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      <article className="rec-article">
        <header className="rec-hero">
          <h1>{t('completeMensGroomingGuide')}</h1>
          <p className="rec-meta">{t('professionalBarberingGuide')}</p>
          <p className="rec-dek">
            {t('masterArtMensGrooming')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/barbershop">{t('bookBarberAppointment')}</Link>
            <Link className="btn outline" to="/service/barbershop">{t('viewAllServices')}</Link>
          </div>
        </header>

        <nav className="rec-toc" aria-label="Table of Contents">
          <h2>{t('tableOfContents')}</h2>
          <div className="rec-toc-summary">
            <p><strong>5 {t('sections')}</strong> • <strong>46 {t('minTotalRead')}</strong></p>
          </div>
          <ul className="rec-toc-list">
            <li className="rec-toc-item">
              <a href="#mustache-styles" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'mustache-styles')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('masterMustacheStyles')}</h3>
                  <p className="rec-toc-description">{t('discoverClassicModern')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">10 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#haircuts" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'haircuts')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('professionalMensHaircut')}</h3>
                  <p className="rec-toc-description">{t('masterHottestHaircut')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">12 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--intermediate">{t('intermediate')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#beard-care" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'beard-care')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('completeBeardCare')}</h3>
                  <p className="rec-toc-description">{t('learnProfessionalBeard')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">8 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#skincare" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'skincare')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('mensSkincareMastery')}</h3>
                  <p className="rec-toc-description">{t('buildProfessionalSkincare')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">9 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#grooming-tools" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'grooming-tools')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('professionalGroomingTools')}</h3>
                  <p className="rec-toc-description">{t('buildProfessionalGrooming')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">7 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--intermediate">{t('intermediate')}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </nav>

        <section id="mustache-styles" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('masterMustacheStyles')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">10 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recBarberMustacheIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('considerFaceShape')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('startWithStyle')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('factorProfessional')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recBarberMustacheContent1')}</p>
              
              <h4>{t('recBarberMustacheContent2')}</h4>
              
              <h5>{t('recBarberMustacheContent3')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberMustacheContent5')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent6')}</strong> {t('recBarberMustacheContent7')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent8')}</strong> {t('recBarberMustacheContent9')}
              </p>
              
              <h5>{t('recBarberMustacheContent10')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberMustacheContent11')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent6')}</strong> {t('recBarberMustacheContent12')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent13')}</strong> {t('recBarberMustacheContent14')}
              </p>
              
              <h5>{t('recBarberMustacheContent15')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberMustacheContent16')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent6')}</strong> {t('recBarberMustacheContent17')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent8')}</strong> {t('recBarberMustacheContent18')}
              </p>
              
              <h5>{t('recBarberMustacheContent19')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberMustacheContent20')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent6')}</strong> {t('recBarberMustacheContent21')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent13')}</strong> {t('recBarberMustacheContent22')}
              </p>
              
              <h4>{t('recBarberMustacheContent23')}</h4>
              
              <h5>{t('recBarberMustacheContent24')}</h5>
              <ul>
                <li><strong>{t('recBarberMustacheContent25')}</strong> {t('recBarberMustacheContent26')}</li>
                <li><strong>{t('recBarberMustacheContent27')}</strong> {t('recBarberMustacheContent28')}</li>
                <li><strong>{t('recBarberMustacheContent29')}</strong> {t('recBarberMustacheContent30')}</li>
                <li><strong>{t('recBarberMustacheContent31')}</strong> {t('recBarberMustacheContent32')}</li>
              </ul>
              
              <h5>{t('recBarberMustacheContent33')}</h5>
              <ul>
                <li><strong>{t('recBarberMustacheContent34')}</strong> {t('recBarberMustacheContent35')}</li>
                <li><strong>{t('recBarberMustacheContent36')}</strong> {t('recBarberMustacheContent37')}</li>
                <li><strong>{t('recBarberMustacheContent38')}</strong> {t('recBarberMustacheContent39')}</li>
                <li><strong>{t('recBarberMustacheContent40')}</strong> {t('recBarberMustacheContent41')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="haircuts" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('professionalMensHaircut')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">12 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--intermediate">{t('intermediate')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recBarberHaircutIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberHaircutQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberHaircutQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberHaircutQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recBarberHaircutContent1')}</p>
              
              <h4>{t('recBarberHaircutContent2')}</h4>
              
              <h5>{t('recBarberHaircutContent3')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberHaircutContent4')}
              </p>
              <p>
                <strong>{t('recBarberHaircutContent5')}</strong> {t('recBarberHaircutContent6')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent8')}</strong> {t('recBarberHaircutContent7')}
              </p>
              
              <h5>{t('recBarberHaircutContent8')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberHaircutContent9')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent6')}</strong> {t('recBarberHaircutContent10')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent13')}</strong> {t('recBarberHaircutContent11')}
              </p>
              
              <h5>{t('recBarberHaircutContent12')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberHaircutContent13')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent6')}</strong> {t('recBarberHaircutContent14')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent13')}</strong> {t('recBarberHaircutContent15')}
              </p>
              
              <h5>{t('recBarberHaircutContent16')}</h5>
              <p>
                <strong>{t('recBarberMustacheContent4')}</strong> {t('recBarberHaircutContent17')}
              </p>
              <p>
                <strong>{t('recBarberHaircutContent18')}</strong> {t('recBarberHaircutContent19')}
              </p>
              <p>
                <strong>{t('recBarberMustacheContent8')}</strong> {t('recBarberHaircutContent20')}
              </p>
              
              <h4>{t('recBarberHaircutContent21')}</h4>
              
              <h5>{t('recBarberHaircutContent22')}</h5>
              <ul>
                <li><strong>{t('recBarberHaircutContent23')}</strong> {t('recBarberHaircutContent24')}</li>
                <li><strong>{t('recBarberHaircutContent25')}</strong> {t('recBarberHaircutContent26')}</li>
                <li><strong>{t('recBarberHaircutContent27')}</strong> {t('recBarberHaircutContent28')}</li>
                <li><strong>{t('recBarberHaircutContent29')}</strong> {t('recBarberHaircutContent30')}</li>
              </ul>
              
              <h5>{t('recBarberHaircutContent31')}</h5>
              <ul>
                <li><strong>{t('recBarberHaircutContent32')}</strong> {t('recBarberHaircutContent33')}</li>
                <li><strong>{t('recBarberHaircutContent34')}</strong> {t('recBarberHaircutContent35')}</li>
                <li><strong>{t('recBarberHaircutContent36')}</strong> {t('recBarberHaircutContent37')}</li>
                <li><strong>{t('recBarberHaircutContent38')}</strong> {t('recBarberHaircutContent39')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="beard-care" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('completeBeardCare')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">8 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recBarberBeardIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberBeardQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberBeardQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberBeardQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recBarberBeardContent1')}</p>
              
              <h4>{t('recBarberBeardContent2')}</h4>
              
              <h5>{t('recBarberBeardContent3')}</h5>
              <ul>
                <li><strong>{t('recBarberBeardContent4')}</strong> {t('recBarberBeardContent5')}</li>
                <li><strong>{t('recBarberBeardContent6')}</strong> {t('recBarberBeardContent7')}</li>
                <li><strong>{t('recBarberBeardContent8')}</strong> {t('recBarberBeardContent9')}</li>
                <li><strong>{t('recBarberBeardContent10')}</strong> {t('recBarberBeardContent11')}</li>
                <li><strong>{t('recBarberBeardContent12')}</strong> {t('recBarberBeardContent13')}</li>
              </ul>
              
              <h5>{t('recBarberBeardContent14')}</h5>
              <ul>
                <li><strong>{t('recBarberBeardContent15')}</strong> {t('recBarberBeardContent16')}</li>
                <li><strong>{t('recBarberBeardContent17')}</strong> {t('recBarberBeardContent18')}</li>
                <li><strong>{t('recBarberBeardContent19')}</strong> {t('recBarberBeardContent20')}</li>
                <li><strong>{t('recBarberBeardContent21')}</strong> {t('recBarberBeardContent22')}</li>
              </ul>
              
              <h4>{t('recBarberBeardContent23')}</h4>
              
              <h5>{t('recBarberBeardContent24')}</h5>
              <ul>
                <li><strong>{t('recBarberBeardContent25')}</strong> {t('recBarberBeardContent26')}</li>
                <li><strong>{t('recBarberBeardContent27')}</strong> {t('recBarberBeardContent28')}</li>
                <li><strong>{t('recBarberBeardContent29')}</strong> {t('recBarberBeardContent30')}</li>
                <li><strong>{t('recBarberBeardContent31')}</strong> {t('recBarberBeardContent32')}</li>
              </ul>
              
              <h5>{t('recBarberBeardContent33')}</h5>
              <ul>
                <li><strong>{t('recBarberBeardContent34')}</strong> {t('recBarberBeardContent35')}</li>
                <li><strong>{t('recBarberBeardContent36')}</strong> {t('recBarberBeardContent37')}</li>
                <li><strong>{t('recBarberBeardContent38')}</strong> {t('recBarberBeardContent39')}</li>
                <li><strong>{t('recBarberBeardContent40')}</strong> {t('recBarberBeardContent41')}</li>
                <li><strong>{t('recBarberBeardContent42')}</strong> {t('recBarberBeardContent43')}</li>
              </ul>
              
              <h4>{t('recBarberBeardContent44')}</h4>
              
              <h5>{t('recBarberBeardContent45')}</h5>
              <p>
                <strong>{t('recBarberBeardContent46')}</strong> {t('recBarberBeardContent47')}
              </p>
              <p>
                <strong>{t('recBarberBeardContent48')}</strong> {t('recBarberBeardContent49')}
              </p>
              
              <h5>{t('recBarberBeardContent50')}</h5>
              <p>
                <strong>{t('recBarberBeardContent46')}</strong> {t('recBarberBeardContent51')}
              </p>
              <p>
                <strong>{t('recBarberBeardContent48')}</strong> {t('recBarberBeardContent52')}
              </p>
              
              <h5>{t('recBarberBeardContent53')}</h5>
              <p>
                <strong>{t('recBarberBeardContent46')}</strong> {t('recBarberBeardContent54')}
              </p>
              <p>
                <strong>{t('recBarberBeardContent48')}</strong> {t('recBarberBeardContent55')}
              </p>
              </div>
            </div>
          </div>
        </section>

        <section id="skincare" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('mensSkincareMastery')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">9 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recBarberSkincareIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberSkincareQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberSkincareQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberSkincareQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recBarberSkincareContent1')}</p>
              
              <h4>{t('recBarberSkincareContent2')}</h4>
              
              <h5>{t('recBarberSkincareContent3')}</h5>
              <ul>
                <li><strong>{t('recBarberSkincareContent4')}</strong> {t('recBarberSkincareContent5')}</li>
                <li><strong>{t('recBarberSkincareContent6')}</strong> {t('recBarberSkincareContent7')}</li>
                <li><strong>{t('recBarberSkincareContent8')}</strong> {t('recBarberSkincareContent9')}</li>
                <li><strong>{t('recBarberSkincareContent10')}</strong> {t('recBarberSkincareContent11')}</li>
              </ul>
              
              <h5>{t('recBarberSkincareContent12')}</h5>
              <ul>
                <li><strong>{t('recBarberSkincareContent4')}</strong> {t('recBarberSkincareContent13')}</li>
                <li><strong>{t('recBarberSkincareContent14')}</strong> {t('recBarberSkincareContent15')}</li>
                <li><strong>{t('recBarberSkincareContent16')}</strong> {t('recBarberSkincareContent17')}</li>
                <li><strong>{t('recBarberSkincareContent8')}</strong> {t('recBarberSkincareContent18')}</li>
              </ul>
              
              <h4>{t('recBarberSkincareContent19')}</h4>
              
              <h5>{t('recBarberSkincareContent20')}</h5>
              <p>
                <strong>{t('recBarberBeardContent46')}</strong> {t('recBarberSkincareContent21')}
              </p>
              <p>
                <strong>{t('recBarberBeardContent48')}</strong> {t('recBarberSkincareContent22')}
              </p>
              
              <h5>{t('recBarberSkincareContent23')}</h5>
              <p>
                <strong>{t('recBarberBeardContent46')}</strong> {t('recBarberSkincareContent24')}
              </p>
              <p>
                <strong>{t('recBarberBeardContent48')}</strong> {t('recBarberSkincareContent25')}
              </p>
              
              <h5>{t('recBarberSkincareContent26')}</h5>
              <p>
                <strong>{t('recBarberBeardContent46')}</strong> {t('recBarberSkincareContent27')}
              </p>
              <p>
                <strong>{t('recBarberBeardContent48')}</strong> {t('recBarberSkincareContent28')}
              </p>
              
              <h4>{t('recBarberSkincareContent29')}</h4>
              
              <h5>{t('recBarberSkincareContent30')}</h5>
              <p>{t('recBarberSkincareContent31')}</p>
              
              <h5>{t('recBarberSkincareContent32')}</h5>
              <p>{t('recBarberSkincareContent33')}</p>
              </div>
            </div>
          </div>
        </section>

        <section id="grooming-tools" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('professionalGroomingTools')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">7 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--intermediate">{t('intermediate')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recBarberToolsIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberToolsQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberToolsQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recBarberToolsQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recBarberToolsContent1')}</p>
              
              <h4>{t('recBarberToolsContent2')}</h4>
              
              <h5>{t('recBarberToolsContent3')}</h5>
              <ul>
                <li><strong>{t('recBarberToolsContent4')}</strong> {t('recBarberToolsContent5')}</li>
                <li><strong>{t('recBarberToolsContent6')}</strong> {t('recBarberToolsContent7')}</li>
                <li><strong>{t('recBarberToolsContent8')}</strong> {t('recBarberToolsContent9')}</li>
                <li><strong>{t('recBarberToolsContent10')}</strong> {t('recBarberToolsContent11')}</li>
              </ul>
              
              <h5>{t('recBarberToolsContent12')}</h5>
              <ul>
                <li><strong>{t('recBarberToolsContent13')}</strong> {t('recBarberToolsContent14')}</li>
                <li><strong>{t('recBarberToolsContent15')}</strong> {t('recBarberToolsContent16')}</li>
                <li><strong>{t('recBarberToolsContent17')}</strong> {t('recBarberToolsContent18')}</li>
                <li><strong>{t('recBarberToolsContent19')}</strong> {t('recBarberToolsContent20')}</li>
              </ul>
              
              <h5>{t('recBarberToolsContent21')}</h5>
              <ul>
                <li><strong>{t('recBarberToolsContent22')}</strong> {t('recBarberToolsContent23')}</li>
                <li><strong>{t('recBarberToolsContent24')}</strong> {t('recBarberToolsContent25')}</li>
                <li><strong>{t('recBarberToolsContent26')}</strong> {t('recBarberToolsContent27')}</li>
                <li><strong>{t('recBarberToolsContent28')}</strong> {t('recBarberToolsContent29')}</li>
              </ul>
              
              <h4>{t('recBarberToolsContent30')}</h4>
              
              <h5>{t('recBarberToolsContent31')}</h5>
              <ul>
                <li><strong>{t('recBarberToolsContent32')}</strong> {t('recBarberToolsContent33')}</li>
                <li><strong>{t('recBarberToolsContent34')}</strong> {t('recBarberToolsContent35')}</li>
                <li><strong>{t('recBarberToolsContent36')}</strong> {t('recBarberToolsContent37')}</li>
                <li><strong>{t('recBarberToolsContent38')}</strong> {t('recBarberToolsContent39')}</li>
              </ul>
              
              <h5>{t('recBarberToolsContent40')}</h5>
              <ul>
                <li><strong>{t('recBarberToolsContent41')}</strong> {t('recBarberToolsContent42')}</li>
                <li><strong>{t('recBarberToolsContent43')}</strong> {t('recBarberToolsContent44')}</li>
                <li><strong>{t('recBarberToolsContent45')}</strong> {t('recBarberToolsContent46')}</li>
                <li><strong>{t('recBarberToolsContent47')}</strong> {t('recBarberToolsContent48')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <footer className="rec-footer">
          <h3>{t('readyElevateGrooming')}</h3>
          <p>
            {t('dontWaitTry')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/barbershop">{t('bookBarberAppointment')}</Link>
            <Link className="btn outline" to="/service/barbershop">{t('viewAllServices')}</Link>
          </div>
        </footer>
      </article>
    </div>
  );
}